import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { catchError, tap, take } from 'rxjs/operators';
import { Demographics } from 'src/app/models/demographics';
import { ScreeningInvite } from 'src/app/models/screeningInvite';
import { SimpleDataFilter } from 'src/app/models/simpleDataFilter';
import { ClientPackagePricing } from 'src/app/packages-module/models/clientPackagePrice';
import { SearchFee, SearchFeeLookupPayload, SearchPackage, SearchRecord } from 'src/app/packages-module/models/searchPackage';
import { FilteringService } from 'src/app/services/filtering.service';
import { SearchPackageService } from 'src/app/services/search-package.service';
import { ScreeningDraftService } from '../../services/screening-draft.service';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-create-pkg-select',
  templateUrl: './create-pkg-select.component.html',
  styleUrls: ['./create-pkg-select.component.less']
})
export class CreatePkgSelectComponent implements OnInit, OnDestroy {

  
  
  packageLoaded$ : Subscription;
  selectedpkg: SearchPackage;
  @Output() public phaseComplete: EventEmitter<number> = new EventEmitter();

  constructor(public packageService: SearchPackageService, 
    private filtering: FilteringService, 
    public drafts : ScreeningDraftService,
    public toast : ToastrService) { }

  ngOnInit() {
    this.packageLoaded$ = this.packageService.packagesLoaded.subscribe(pkg =>{
      if(this.drafts.directOrderDemographics.searchPackageId){
        let pk = this.packageService.searchPackages.find(pkg =>{ return pkg.id == this.drafts.directOrderDemographics.searchPackageId});
        pk.selected = true;
        // this.selectedpkg = pk;
        this.selectPackage(pk);
      }
    })


    this.filtering.filters = [];
    // this.filtering.filters.push(new SimpleDataFilter('clientId', this.drafts.directOrderDemographics.clientId.toString(), true));
    this.packageService.FetchFullSearchPackagesListForUser(this.drafts.directOrderDemographics.clientId);
    this.packageService.GetClientSearchPackageOverrideList(this.drafts.directOrderDemographics.clientId)
    .pipe(
      take(1),
      tap((scc: ClientPackagePricing[]) => {
        this.drafts.clientPackageOverrides = scc;
    })).subscribe(null,(err: any)=>{
        this.toast.error('Error Fetching Search Package List');
    });
  }


  ngOnDestroy() {
    try {
      this.packageLoaded$.unsubscribe();
      this.packageService._searchPackages = [];
      this.drafts.clientPackageOverrides = [];
    } catch (error) {
      
    }
  }

  // Public properties
  public get searchPackages(): SearchPackage[] {
    return this.packageService.searchPackages.filter(pkg =>{ return pkg.clientIds.includes(this.drafts.directOrderDemographics.clientId)}).map((sp: SearchPackage) => {
      if (this.drafts.clientPackageOverrides) {
        const override = this.drafts.clientPackageOverrides.find(spo => {
          return spo.searchPackageId === sp.id;
        });
        if (override) {
          sp.cost = override.clientPackageCost;
        }
      }
      return sp;
    });
  }

  public searchesString(pkg: SearchPackage): string {
    let s = '';
    pkg.searches.forEach((search: SearchRecord) => {
      if (s.length === 0) {
        s += search.name;
      } else {
        s += ', ' + search.name;
      }
    });
    return s;
  }

  selectPackage(pkg: SearchPackage) {
    this.packageService.searchPackages.forEach(p => {
      p.selected = false;
    });
    pkg.selected = true;
    this.selectedpkg = pkg;
    this.drafts.directOrderDemographics.searchPackageId = pkg.id;
    this.drafts.directOrderDemographics.hasVerificationsInPackage = pkg.containsVerifications;
    
  }

  continue(){
    if(!this.drafts.directOrderDemographics.searchPackageId)
    {
      this.toast.error('Please select a search package for your report.');
      return;
    }else
    {
      // update the draft
      if(this.drafts.directOrderDemographics.lastCompletedPhase <= 2)  this.drafts.directOrderDemographics.lastCompletedPhase = 2;

      //if we don't have any verifications, we need to mark that step as completed so the user doesn't load back into phase 3.
      if(!this.selectedpkg.containsVerifications) this.drafts.directOrderDemographics.lastCompletedPhase = 3;
      // this.drafts.directOrderDemographics.posReportCost = this.reportCost;
      this.drafts.SaveDraft(this.drafts.directOrderDemographics).pipe(take(1), tap(_ =>{
        Object.assign(this.drafts.directOrderDemographics,_);
      })).subscribe(null,()=>{
        this.toast.error('There was an error setting the search packge for your draft.', 'Draft update error');
      },
      ()=>{
        this.phaseComplete.next(2);
      });
    }
  }

  back(){
    this.phaseComplete.next(0);
  }

}
